
export enum ErrorTypes {
    DefaultError,
    AuthError,
    MustLogin,
    MustBeMember,
    Blocking,
}

export enum HTTPStatus {
    Ok = 200, // Request succeeded
    BadRequest = 400, // Cannot process request due to client-side issues, such as malformed syntax or invalid data
    Unauthorized = 401, // The request requires authentication, and the provided credentials are invalid or missing
    Forbidden = 403, // Client does not have permission, despite having provided valid credentials
    NotFound = 404, // Resource not found on the server
    Conflict = 409, // Request conflict with the current state of the target resource
    TooManyRequests = 429, // Too many requests, so server throttled access
    InternalServerError = 500, // Server error, can't fulfill request
    ServiceUnavailable = 503, // Server temporarily unable to handle request, due to maintenance or overload
}
